import styles from "./ProductList.css";
import PropTypes from "prop-types";
import { withTranslation } from "../translation";
import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";

const ResultsSpinner = ({ formatTranslation }) => (
  <>
    <span className={styles.srOnly} role="alert" id="alert">
      {formatTranslation("generic_accessibility_loading_products")}
    </span>
    <div className={styles.overlay} data-auto-id="productListSpinner">
      <span className={styles.mask} />
      <ProgressIndicator transparent={false} />
    </div>
  </>
);

ResultsSpinner.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(ResultsSpinner);
